import { TooltipProps } from '@rsa-digital/evo-shared-components/components/Form/Field/FieldInfo';
import { CsQuestion } from 'types/contentStack';
import { trackTooltipClick } from './eventTracking';

export const processTooltip = (question: CsQuestion): TooltipProps | undefined => {
  if (question.main_details.tooltip?.tooltip_text) {
    const openButtonText = question.main_details.tooltip.tooltip_open || 'Open';
    const closeButtonText = question.main_details.tooltip.tooltip_close || 'Close';
    return {
      body: question.main_details.tooltip.tooltip_text,
      buttonText: {
        open: openButtonText,
        close: closeButtonText,
      },
      onExpand: trackTooltipClick(
        'Expand',
        openButtonText,
        question.main_details.question_text
      ),
      onCollapse: trackTooltipClick(
        'Collapse',
        closeButtonText,
        question.main_details.question_text
      ),
    };
  }
  return undefined;
};

export const processShowIfField = (
  question: CsQuestion
): { value: string; to_contain: string } | undefined => {
  if (!question.show_if_field || question.show_if_field === null) {
    return undefined;
  }
  const { value, to_contain } = question.show_if_field;
  if (!value || !to_contain) {
    return undefined;
  }
  return { value, to_contain };
};
